<mat-tab-group>
  <mat-tab label="Forms">
    <div class="training-component">
      <div style="display: flex; flex-direction: row;" [ngStyle]="{ gap: collapsed ? '0': '40px' }">
        <div style="display: flex; flex-direction: column; margin-left: 40px;position:relative; padding-top: 30px;" [ngStyle]="{ flex: collapsed ? '0 0 30px': '0 0 300px' }"
             class="list">
          <div style="position: absolute; top:10px; right: 10px;" (click)="collapsed = !collapsed">
            <i [class]="collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"></i>
          </div>
          <div *ngIf="!collapsed" style="margin-left: 30px">
            <h3>{{pageTitle}}</h3>
            <div *ngFor="let quiz of assessments" style="white-space: nowrap;">
              <div style="display: flex; flex-direction: row;">
                <a style="display: inline-block;text-overflow: ellipsis;width: 100%;overflow:hidden; flex:0 1 auto"
                   [pTooltip]="quiz.quizData.name + (canEdit ?  ' last updated on ' + (quiz.modifiedDate | date : 'shortDate') + ' by ' + quiz.modifiedBy : '')"
                   [routerLink]="['/assessments/assessment', quiz.id]"
                   class="training-link"
                   routerLinkActive="active">{{quiz.quizData.name || "Default"}}<sup
                  *ngIf="canEdit">{{quiz.submissions}}</sup></a>
                <i style="display: inline-block; flex:1 1 auto" *ngIf="canEdit"
                   [routerLink]="['/assessments/assessment', quiz.id, 'edit']"
                   class="fa fa-pencil" pTooltip="Edit Survey" tooltipPosition="top"
                   ></i>
                <i style="display: inline-block; flex:1 1 auto" *ngIf="canEdit && canCreateAssesment" (click)="copyAssessment(quiz)"
                   class="fa fa-copy" pTooltip="Duplicate Survey" tooltipPosition="top"
                   ></i>
              </div>
              <div *ngFor="let answer of quiz.unfinishedAnswers" style="font-size: 0.7em; margin-left: 20px; flex:0 1 auto">
                <a style="display: inline-block;text-overflow: ellipsis;width: 100%;overflow:hidden"
                   [pTooltip]="'Unfinished survey for ' + (answer.versionName || quiz.quizData.name)"
                   [routerLink]="['/assessments/assessment', answer.assessmentId, answer.id]"
                   class="training-link"
                   routerLinkActive="active">
                  <ng-container *ngIf="answer.completionName">
                    {{answer.completionName}}
                  </ng-container>
                  <ng-container *ngIf="!answer.completionName">
                    {{answer.date | date:'shortDate'}} {{answer.date | date:'shortTime'}}
                  </ng-container>
                </a>
                <i style="display: inline-block; flex:1 1 auto; " (click)="deleteAssessmentAnswer(answer)"
                   class="fa fa-trash" pTooltip="Delete Answer" tooltipPosition="top"
                   ></i>
              </div>
            </div>
            <div style="margin-left: 10px;" *ngIf="canCreateAssesment">
              <a [routerLink]="['/assessments/assessment', 0, 'edit']" pTooltip="Create Survey" tooltipPosition="top">
                <div class="fa fa-plus"></div>
              </a>
              <label
                style="margin-left: 10px;"
                type="button"
                [for]="'flieBlobUpload'"
                class="fa fa-upload"
                pTooltip="Upload Asssessment. {{this.constants.ATTACHMENT_FILE_DESCRIPTION}}" tooltipPosition="top">
              </label>
              <input [id]="'flieBlobUpload'"
                     type="file"
                     accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                     (change)="uploadAssessment($event)"
                     name="addAttachedFile1"
                     style="display: none;" />
            </div>
          </div>
        </div>
        <div style="width: calc(100% - 380px);">
          <router-outlet></router-outlet>
        </div>

      </div>
    </div>
  </mat-tab>
  <mat-tab label="Results" *ngIf="canEdit">
    <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">

      <form class="example-form" *ngIf="isInviteVisible">
        <button mat-raised-button
                [routerLink]="['/inviteSurvey']"
                style="border-radius: 6px; margin: 10px;">
          Bulk Registration
        </button>
      </form>

    </div>
    <assessmentSummary-component></assessmentSummary-component>
  </mat-tab>
</mat-tab-group>
